<template>
  <modal name="contract-request-modal"
         @closed="$emit('updateComparisonData')"
         @before-open="handleBeforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Պայմանագրի կնքում</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('contract-request-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="width: 120px;">Հ/Հ</th>
            <th>Մասնակցի անվանում</th>
            <th>Մասնակցի հեռախոսահամար</th>
            <th>Մասնակցի Էլ. հասցե</th>
            <!-- <th>Պայմանագրի պատասխան</th> -->
            <th>Կնքում</th>
          </tr>
        </thead>
        <tbody id="negotiation-table" style="min-height: 5vh; max-height: 40vh!important; overflow: scroll">
          <template v-for="(winner, winnerIndex) in winners">
              <tr v-if="!getIsSigned(winner)" :key="winnerIndex">
                <td>{{ winnerIndex+1 }}</td>
                <td>{{ winner.name }}</td>
                <td>{{ winner.phone }}</td>
                <td>{{ winner.email }}</td>
                <!-- <td>
                  <select v-model="participantGroup.contractResponse" class="form-control">
                    <option :value="true">Ստացվել է</option>
                    <option :value="false">Չի ստացվել</option>
                  </select>
                </td> -->
                <td>
                  <div class="row">
                    <div class="col-6">
                      <button
                        @click.prevent="() => {
                          $modal.show('contract-sign-modal', {winner, confirmContract})
                        }"
                        type="button" 
                        class="btn btn-sm btn-success">
                          Ուղարկել պայմանագրի առաջարկ
                      </button>
                    </div>
                    <div class="col-6">
                      <button
                        @click="cancelContract(winner)"
                        type="button" 
                        class="btn btn-sm btn-danger">
                          Չեղարկել
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
        </tbody>
      </table>
      <infinite-loading slot="append"
                        class="w-100"
                        ref="negotiationInfiniteLoading"
                        @infinite="infiniteHandler"
                        force-use-infinite-wrapper="#negotiation-table">
        <div slot="no-results"></div>
        <div slot="no-more"></div>
      </infinite-loading>
    </div>
    <contract-sign-modal />
  </modal>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import ContractSignModal from './ContractSignModal'

  export default {
    name: 'ContractRequestModal',
    components: { InfiniteLoading, ContractSignModal },
    data() {
      return {
        winners: [],
        pagination: {},
      }
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organizeItender/currentOrganized']
      },
      locale() {
        return this.$store.getters['user/locale']
      }
    },
    methods: {
      getIsSigned(winner){
        var isSigned = true;
        winner.won_lots.forEach((lot) => {
          const offer = this.currentOrganized.lots.find(item => item.organize_row_id === lot.id && (item.participant_id === winner.id || item.row_group_id === winner.id))

          if(!offer.get_response){
            isSigned = false;
          }
        })
        return isSigned
      },
      confirmContract(winner) {
        winner.won_lots.forEach((lot) => {
          const offer = this.currentOrganized.lots.find(item => item.organize_row_id === lot.id && (item.participant_id === winner.id || item.row_group_id === winner.id))

          this.$client.put(`participant-row/${offer.id}`, {get_response: true})
        })
        const optionIndex = this.winners.findIndex(item => item.id === winner.id)
        this.winners.splice(optionIndex, 1)
      },
      handleBeforeOpen(){
        this.winners = [...this.currentOrganized.winners]
      },
      cancelContract(winner) {
        winner.won_lots.forEach((lot) => {
          this.$client.delete(`participant-row/${lot.won_lot_id}`)
        })
        this.$client.put(`organize/itender/${this.$route.params.id}`, {create_contract: 0})
        const optionIndex = this.winners.findIndex(item => item.id === winner.id)
        this.winners.splice(optionIndex, 1)
      },
      async infiniteHandler($state) {
        this.participantGroups = [];
        await this.$client.get(`participant-group/getByOrganize/getWonLots/${this.$route.params.id}`).then(response => {
          const results = response.data;
          if(results) {
            results.forEach(participant => {
              if(participant.won_lots.length>0){
                participant.contractResponse = false;
                this.participantGroups.push(participant)
              }
            });
            $state.complete()
          } else{
            $state.complete()
          }
        }).catch(e => {
          $state.complete()
        })
      },
      consoleLog(msg) {
        console.log(msg)
      },
      getNewOverall(participant) {
        let overall = null
        if(participant.new_price) {
          overall = participant.new_price
          if(participant.vat) {
            overall += participant.new_price*0.2
          }
        }
        if(overall) {
          return Number(overall.toFixed(2))
        }

        return overall
      },
    }
  }
</script>

<style scoped>

</style>